const generateId = (length)=>{
    const arr = new Uint8Array(length / 2);
    window.crypto.getRandomValues(arr);
    return `a${Array.from(arr, (b)=>`0${b.toString(16)}`.slice(-2)).join("")}`;
};
export { generateId };
